export default {
    getOpenSessions
}

function getOpenSessions(state){
    return _.filter(state.sessions, session => {
        return session.REGISTRATION_OPEN
    })
}